module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/img-wedding-compact-light-d0d5842efe0dd5ca002c0b2112c9b694.png";